import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  HEARD_ON_THE_STREET = 'Heard on the Street',
  STREETWISE = 'Streetwise',
  THE_INTELLIGENT_INVESTOR = 'The Intelligent Investor',
  CAPITAL_ACCOUNT = 'Capital Account'
}
const { CAPITAL_ACCOUNT, HEARD, MARKETS, STREET_WISE, THE_INTELLIGENT_INVESTOR } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [MARKETS, STREET_WISE, THE_INTELLIGENT_INVESTOR, HEARD] } }
    ]
  },
  ...DEFAULT_SORT
};

const HEARD_QUERY = createSupportingModule([HEARD]);
const STREETWISE_QUERY = createSupportingModule([STREET_WISE]);
const THE_INTELLIGENT_INVESTOR_QUERY = createSupportingModule([THE_INTELLIGENT_INVESTOR]);
const CAPITAL_ACCOUNT_QUERY = createSupportingModule([CAPITAL_ACCOUNT]);

export {
  SECTION_ENUM,
  baseQuery as MAIN,
  HEARD_QUERY,
  STREETWISE_QUERY,
  THE_INTELLIGENT_INVESTOR_QUERY,
  CAPITAL_ACCOUNT_QUERY
};
